import React from 'react';
import { Page, Text, View, Document, StyleSheet, PDFViewer, PDFDownloadLink } from '@react-pdf/renderer'; // https://react-pdf.org

const HEADER_STYLE = true
const BODY_STYLE = false

// Create styles
const styles = StyleSheet.create({
    page: {
        display: "flex",
        flexFlow: "col nowrap",
        // backgroundColor: "#E4E4E4",
        alignItems: "flex-start",
        // justifyContent: "flex-end",
        // margin: "10pt",
        padding: "10pt",
        fontSize: "14pt",
    },
    header: {
        display: "flex",
        flexDirection: 'row',
        alignItems: "flex-start",
        // flexFlow: 'row nowrap',
        flex: "0 0 100%",
        //minWidth: "100%",
        // flexGrow: "1",
        width: "100%",
        // margin: "1pt",
        // padding: "10pt",

        // borderBottomStyle: "solid",
        // borderBottomColor: "green",
        // borderBottomWidth: "2pt",
        // maxHeight: "40pt",
    },
    periodSectionHeader: {
        display: "flex",
        flexDirection: "row",
        // alignItems: "flex-end",
        flex: "0 0 20%",
        width: "20%",
        // border: "1pt solid black",

    },
    debtSectionHeader: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        flex: "0 0 80%",
        width: "80%",
        // border: "1pt solid red",
    },
    summaryRow: {
        display: "flex",
        flexDirection: 'row',
        // justifyContent: "space-around",
        alignItems: "center",
        flex: "0 0 100%",
        // alignItems: "center",
        // flexFlow: 'row nowrap',
        width: "100%",
        // margin: "0pt",
        padding: "8pt",
        // flexGrow: "1", 
        borderBottomStyle: "solid",
        borderBottomColor: "black",
        borderBottomWidth: "2pt",
        minHeight: "15pt",
    },
    SummaryRowShaded: {
        // display: "flex",
        // justifyContent: "space-around",
        // flexFlow: 'row nowrap',
        flexDirection: 'row',
        width: "100%",
        // alignItems: "flex-start",
        // margin: "0pt",
        padding: "8pt",
        // flexGrow: "1",
        backgroundColor: "#D3D3D3",
        borderBottomStyle: "solid",
        borderBottomColor: "black",
        borderBottomWidth: "2pt",
        minHeight: "15pt",
    },
    periodSection: {
        display: "flex",
        flexDirection: "row",
        flex: "1 0 20%",
        // flexGrow: "0",
        alignItems: "center",
        width: "20%",
        // border: "1pt solid black",

    },
    debtSection: {
        display: "flex",
        flexDirection: "column",
        // alignItems: "flex-start",
        flex: "1 0 80%",
        width: "80%",

        // border: "1pt solid red",
    },
    debtRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        minHeight: "15pt",
        borderBottomStyle: "solid",
        borderBottomColor: "black",
        borderBottomWidth: "1pt",
    },
    defaultCol: {
        // flexFlow: 'row nowrap',
        // justifyContent: "center",
        // alignItems: "center",
        flex: "1",
        // marginBottom: "12pt",
        // margin: "0.3pt",
        // width: "25%",
        padding: "0.3pt",
        // borderStyle: "solid",
        // borderColor: "black",
        // borderWidth: "2pt",
        fontSize: "14pt",
        textAlign: "right"

    },
    periodColHeader: {
        display: "flex",
        flexFlow: 'row nowrap',
        // justifyContent: "center",
        // alignItems: "center",
        flex: "0 0 50%",
        // flexBasis: "25%",
        // marginBottom: "12pt",
        // margin: "0.3pt",
        width: "50%",
        padding: "0.3pt",
        // borderStyle: "solid",
        // borderColor: "black",
        // borderWidth: "2pt",
        // width: "25%",
        // fontSize: "14pt",
        textAlign: "left"

    },
    debtNameColHeader: {
        // flexFlow: 'row nowrap',
        // justifyContent: "flex-end",
        // alignItems: "flex-end",
        flex: "0 0 25%",
        // marginBottom: "12pt",
        // margin: "0.3pt",
        width: "25%",
        // padding: "0.3pt",
        // borderStyle: "solid",
        // borderColor: "black",
        // borderWidth: "2pt",
        // fontSize: "14pt",
        textAlign: "center",

    },
    debtColHeader: {
        // flexFlow: 'row nowrap',
        // justifyContent: "flex-end",
        // alignItems: "flex-end",
        flex: "0 0 25%",
        // marginBottom: "12pt",
        // margin: "0.3pt",
        width: "25%",
        // padding: "0.3pt",
        // borderStyle: "solid",
        // borderColor: "black",
        // borderWidth: "2pt",
        // fontSize: "14pt",
        textAlign: "center",

    },
    periodCol: {
        // flexFlow: 'row nowrap',
        // justifyContent: "center",
        // alignItems: "center",
        flex: "0 0 50%",
        // marginBottom: "12pt",
        // margin: "0.3pt",
        width: "50%",
        padding: "0.3pt",
        // borderStyle: "solid",
        // borderColor: "black",
        // borderWidth: "2pt",
        // fontSize: "14pt",
        textAlign: "left"

    },
    debtNameCol: {
        // flexFlow: 'row nowrap',
        // justifyContent: "flex-end",
        // alignItems: "flex-end",
        flex: "0 0 25%",
        // marginBottom: "12pt",
        // margin: "0.3pt",
        width: "25%",
        // padding: "0.3pt",
        // borderStyle: "solid",
        // borderColor: "black",
        // borderWidth: "2pt",
        // fontSize: "14pt",
        textAlign: "center",

    },
    debtCol: {
        // flexFlow: 'row nowrap',
        // justifyContent: "flex-end",
        // alignItems: "flex-end",
        flex: "0 0 25%",
        // marginBottom: "12pt",
        // margin: "0.3pt",
        width: "25%",
        // padding: "0.3pt",
        // borderStyle: "solid",
        // borderColor: "black",
        // borderWidth: "2pt",
        // fontSize: "14pt",
        textAlign: "right",

    },


});

// maximum number of levels for columns
// each level is nested into the other.  A level 1 row may hold multiple level 2 rows
const MAX_LEVELS = 2

const columns = [
    { id: 'startMonth', label: 'Start\nMonth', minWidth: 10, level: 1 },
    { id: 'endMonth', label: 'End\nMonth', minWidth: 10, level: 1 },
    { id: 'debtName', label: 'Debt', minWidth: 20, level: 2 },
    { id: 'totalPayment', label: 'Payment', minWidth: 20, level: 2, format: value => value.toFixed(2) },
    { id: 'interestToDate', label: 'Total\nInterest', minWidth: 20, level: 2, format: value => value.toFixed(2) },
    { id: 'paymentsToDate', label: 'Total\nPayments', minWidth: 20, level: 2, format: value => value.toFixed(2) }
];


export default function PayoffSummaryPDF(props) {

    const getColStyle = (colId, header) => {

        let rtnValue
        switch (colId.toLowerCase()) {

            case "startmonth":
            case "endmonth":
                rtnValue = header ? styles.periodColHeader : styles.periodCol
                break
            case "debtname":
                rtnValue = header ? styles.debtNameColHeader : styles.debtNameCol
                break
            case "totalpayment":
            case "interesttodate":
            case "paymentstodate":
                rtnValue = header ? styles.debtColHeader : styles.debtCol
                break
            default:
                rtnValue = styles.defaultCol
        }

        return rtnValue
    }

    const buildSummaryRows = (summaries) => {

        // create flex boxes for each summary row.
        // there will be a main container
        // and a nested container for each level
        let summaryRows = new Array()

        for (let summary of summaries) {

            // put each element in the container for that level
            let summaryRow = (

                <View style={styles.summaryRow}>
                    <View style={styles.periodSection}>
                        {
                            columns.map((column) => {
                                let value
                                let rtnValue = null

                                if (column.level === 1) {
                                    value = summary[column.id];
                                    rtnValue = (
                                        <Text key={column.id} style={getColStyle(column.id, BODY_STYLE)}>
                                            {column.format && typeof value === 'number' ? column.format(value) : value}
                                        </Text>
                                    )
                                }
                                return rtnValue;
                            })
                        }
                    </View>
                    <View style={styles.debtSection}>
                        {
                            summary.recs.map((debt) => {
                                return (
                                    <View key={debt.id} style={styles.debtRow}>
                                        {
                                            columns.map((column) => {
                                                let value
                                                let rtnValue = null

                                                if (column.level === 2) {
                                                    value = debt[column.id];

                                                    // only show balance on paid off month
                                                    if (debt.balance != 0.0 && (column.id == "interestToDate" || column.id == "paymentsToDate")) {
                                                        value = null
                                                    }
                                                    rtnValue = (

                                                        <Text key={column.id} style={getColStyle(column.id, BODY_STYLE)}>
                                                            {column.format && typeof value === 'number' ? column.format(value) : value}
                                                        </Text>
                                                    )
                                                }
                                                return rtnValue;
                                            })
                                        }
                                    </View>
                                )
                            })
                        }
                    </View>

                </View>
            )

            summaryRows.push(summaryRow)
        }

        return summaryRows
    }

    return (

        <Page size="LETTER" style={styles.page}>
            <View debug={false} style={styles.header}>
                <View debug={false} style={styles.periodSectionHeader}>
                    {
                        columns.map(column => {

                            let rtnValue = null
                            if (column.level === 1) {
                                rtnValue = (
                                    <Text key={column.id} style={getColStyle(column.id, HEADER_STYLE)}>
                                        {column.label}
                                    </Text>
                                )
                            }
                            return rtnValue
                        })
                    }
                </View>
                <View debug={false} style={styles.debtSectionHeader}>
                    {
                        columns.map(column => {

                            let rtnValue = null
                            if (column.level === 2) {
                                rtnValue = (
                                    <Text key={column.id} style={getColStyle(column.id, HEADER_STYLE)}>
                                        {column.label}
                                    </Text>
                                )
                            }
                            return rtnValue
                        })
                    }
                </View>
            </View>
            {
                buildSummaryRows(props.summary)
            }

        </Page>

    );
}
